import { FC } from 'react';
import { ProjectUrlsType } from './ProjectUrlsTypes.ts';
import { getProjectHasUrls } from './utils/ProjectUrlsUtils.ts';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styles from './ProjectUrls.module.scss';

/**
 * Props for the ProjectUrls component.
 * - `urls`: Object containing the URLs related to the project.
 */
interface ProjectUrlsProps {
    urls: ProjectUrlsType;
}

const ProjectUrls: FC<ProjectUrlsProps> = (props) => {
    const {
        urls
    } = props;

    const {
        t
    } = useTranslation('projectUrls');

    // If there are no URLs to display, return null
    if (!getProjectHasUrls(urls)) {
        return null;
    }

    const githubUrl = urls.github;
    const liveUrl = urls.live;

    return (
        <Container
            className={`${styles.urlsContainer}`}
        >
            <Row
                className='d-flex justify-content-around my-5 mx-4 gap-5'
            >
                {githubUrl && (
                    <Col
                        lg={4}
                        sm={12}
                    >
                        <a
                            className={`${styles.urlLink} ${styles.urlColumn}`}
                            href={githubUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('title.github')}
                        </a>
                    </Col>
                )}
                {liveUrl && (
                    <Col
                        lg={4}
                        sm={12}
                    >
                        <a
                            className={`${styles.urlLink} ${styles.liveColumn} ${styles.urlColumn}`}
                            href={liveUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('title.live')}
                        </a>
                    </Col>
                )}
            </Row>
        </Container>
    );
};

export default ProjectUrls;
